import { render, staticRenderFns } from "./IconHamburgerLinear.vue?vue&type=template&id=67d87960&scoped=true"
import script from "./IconHamburgerLinear.vue?vue&type=script&lang=js"
export * from "./IconHamburgerLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d87960",
  null
  
)

export default component.exports